import React from "react";
import "../css/nanny.css";
import Stepper from "./Steppers/Stepper";
import Header from "../Headers/Header";
import HeaderLink from "../Headers/HeaderLink";
import { MdArrowBackIos, MdOutlineLocationOn } from "react-icons/md";
import { HiOutlineUser } from "react-icons/hi";
import LeftContent from "./LeftContent";

export default function Step2({
  currentStep,
  gotoMomKidCare,
  prev,
  handleChange,
  errors,
  handlePlaceChanged,
  next,
  name,
  location,
  gender,
  isForSelf,
  _next
}) {
  if (currentStep !== 2) {
    return null;
  }
  return (
    <React.Fragment>
      <div className="d-lg-block d-none">
        <Header />
      </div>
      <div className="d-lg-none d-block">
        <HeaderLink gotoMomKidCare={gotoMomKidCare} />
      </div>
      <div className="container p-lg-4  mt-lg-5 pt-lg-0 pt-5">
        <div className="row mx-auto mb-5">
          {/* Partition  one*/}
          <div className="col-lg-5 p-lg-5 pt-5 pt-lg-0">
            <LeftContent gotoMomKidCare={gotoMomKidCare} />
          </div>

          {/* Partition  second*/}
          <div className="col-lg-7 mt-2">
            {/* Right Title */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitle">
                <p className="ml-1 ml-lg-0">Please provide below information</p>
              </div>
            </div>
            {/* Right Title 2nd */}
            <div className="row d-lg-block d-none">
              <div className="col-lg-12 rightTitleSecond">
                <p className="ml-1 ml-lg-0">
                  कृपया नीचे दी गई जानकारी प्रदान करें
                </p>
              </div>
            </div>
            {/* Main Content Form*/}
            <div className="row mx-auto">
              <div className="col-lg-12 mt-1 mainContent rounded">
                <form className="pl-0" onSubmit={(e)=>_next(e)} method='post'>
                <div className="row p-3">
                  <div className="col-lg-12">
                    <div className="row">
                      <div>
                        <div className="d-lg-none d-block">
                          <Stepper />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="backText d-flex align-items-center">
                          <p>
                            <MdArrowBackIos size="15" />
                            {prev}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 personal">
                    <p>
                      Personal Details <span>(व्यक्तिगत जानकारी)</span>
                    </p>
                  </div>
                  <div className="col-lg-12 horizontal-line">
                    <hr />
                  </div>

                  {/* input  */}
                  <div className="col-lg-12 col-12 mt-1">
                    <div
                      className="inp"
                      style={{ border: errors.name && "2px solid red" }}
                    >
                      <HiOutlineUser style={{ color: "#174D82" }} size="20px" />
                      <span>|</span>
                      <input
                        type="text"
                        placeholder="Name (आपका नाम)"
                        name="name"
                        onChange={handleChange}
                        style={{ fontSize: "12px" }}
                        value={name}
                      />
                    </div>
                  </div>
                  {errors.name ? (
                    <span className="custom-error ml-2">{errors.name}</span>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-12 col-12 mt-2">
                    <div
                      className="inp"
                      style={{ border: errors.location && "2px solid red" }}
                    >
                      <MdOutlineLocationOn
                        style={{ color: "#174D82" }}
                        size="20px"
                      />
                      <span>|</span>
                      <input
                        defaultValue={location}
                        type="text"
                        placeholder="Location (आप कहाँ रहते हो)"
                        name="location"
                        id="pac-input"
                        onChange={handlePlaceChanged}
                        // ref={handlePlaceChanged}
                        style={{ fontSize: "12px" }}
                      />
                    </div>
                  </div>
                  {errors.location && (
                    <span className="custom-error ml-2">{errors.location}</span>
                  )}

                  <div className="col-lg-12 mt-3 check">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="gender"
                        onChange={handleChange}
                        id="inlineRadio2"
                        checked={gender == '1'}
                        value="1"
                        style={{ border: errors.gender && "2px solid red" }}
                      />
                      <label class="form-check-label" for="inlineRadio2">
                        Male <span style={{ color: "#6B6B6B" }}>( पुरुष )</span>
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="gender"
                        onChange={handleChange}
                        id="inlineRadio1"
                        value="2"
                        checked={gender == '2'}
                        style={{ border: errors.gender && "2px solid red" }}
                      />
                      <label class="form-check-label" for="inlineRadio1">
                        Female{" "}
                        <span style={{ color: "#6B6B6B" }}>( महिला )</span>
                      </label>
                    </div>
                  </div>
                    {gender == "1" && (
                      <div className="col-lg-12 mt-3 check">
                        <p style={{ fontSize: "13px", marginBottom: "8px", color: "#174D82" }}>
                          Are you looking for this job for yourself?{" "}
                          <span style={{ color: "#6B6B6B" }}>(क्या आप ये नौकरी अपने लिए ढूँढ रहे है?)</span>
                        </p>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="isForSelf"
                            value="1"
                            checked={isForSelf == "1"}
                            onChange={handleChange}
                          />
                          <label className="form-check-label">
                            Yes <span style={{ color: "#6B6B6B" }}>(हाँ)</span>
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="isForSelf"
                            value="2"
                            checked={isForSelf == "2"}
                            onChange={handleChange}
                          />
                          <label className="form-check-label">
                            No <span style={{ color: "#6B6B6B" }}>(नहीं)</span>
                          </label>
                        </div>
                      </div>
                    )}

                  {errors.gender && (
                    <span className="custom-error ml-2">{errors.gender}</span>
                  )}
                  <div className="col-lg-12 mt-5 mb-lg-5 mb-3">{next}</div>
                  <div className="d-lg-block d-none row">
                    <Stepper />
                  </div>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
